import { ticker } from '@/api/server/common/ticker';
import Web3AuthCall from '@/lib/web3/Web3AuthCall';

export const setCurrencyTicker = async (web3authCall: Web3AuthCall) => {
  const obj = {
    symbol: 'SFL',
    amount: '1',
  };
  const tic = await ticker(obj);
  const pk = process.env.REACT_APP_ADMIN_KEY!;
  const contractAddr = process.env.REACT_APP_POOL_CONTRACT!;
  const factoryContract = [process.env.REACT_APP_FACTORY_CONTRACT!];

  await web3authCall?.getAdminWeb3().setStakingFactory(factoryContract);
  await web3authCall?.getAdminWeb3().setStakingPool(contractAddr);
  const re = await web3authCall?.getAdminWeb3().updateTokenMultipliedPrice(contractAddr, tic.data.latest_price, pk);
  return re;
};
